import { Navigate, Outlet, useLocation } from "react-router-dom";
import { usePortalSessionStore } from "@/features/portal/store/portal-session-store";
import { portalSignInHref } from "@/features/portal/portal-base";

/**
 * Portal-session guard — the taxpayer-facing counterpart to `PrivateRoute`.
 * Redirects to the portal sign-in when there's no bound portal session. It
 * checks the portal store only, never the staff `useAuthStore`.
 */
export function PortalRoute() {
  const isPortalAuthenticated = usePortalSessionStore((s) => s.isPortalAuthenticated);
  const portalName = usePortalSessionStore((s) => s.portalName);
  const brandingName = usePortalSessionStore((s) => s.branding?.portalName);
  const location = useLocation();

  if (!isPortalAuthenticated) {
    // Send the taxpayer back to their firm-branded sign-in when we know it.
    const target = portalSignInHref(portalName ?? brandingName);
    return <Navigate to={target} state={{ from: location }} replace />;
  }
  return <Outlet />;
}
